// Ref-counted body scroll lock shared by every modal in the app (components/Modal and
// components/NewModal). The page is locked (body overflow: hidden) while at least one
// modal holds a lock, and goes back to the stylesheet's overflow ('') when the last one
// releases it, whatever order the modals open, close or unmount in.

let count = 0;


// Writes the body overflow that matches the current count. Also used to undo the
// writes @drawbotics/modal makes on its own (see components/Modal).
export function syncScrollLock() {
  document.body.style.overflow = count > 0 ? 'hidden' : '';
}


export function lockScroll() {
  count += 1;
  syncScrollLock();
}


export function unlockScroll() {
  if (count === 0 && process.env.NODE_ENV !== 'production') {
    console.warn('utils/scroll-lock: unlockScroll() called without a matching lockScroll()');
  }
  count = Math.max(0, count - 1);
  syncScrollLock();
}


// Tests only: jest.setup.js checks that every test released its locks, then resets
export function getScrollLockCount() {
  return count;
}


export function resetScrollLock() {
  count = 0;
}
